import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-vs-card',
  templateUrl: './edit-vs-card.component.html',
  styleUrls: ['./edit-vs-card.component.scss']
})
export class EditVsCardComponent implements OnInit, AfterViewInit {
  @Input() cardInfo: any;
  fileImg64: any;
  wrongSize: any;
  cardForm: FormGroup;
  maxLength = 150;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.fileImg64 = this.cardInfo ? this.cardInfo.img : null;
    this.createForm();
  }


  ngAfterViewInit(): void {
    this.updateForm();
  }

  sendData(): any {
    this.cardForm.get('codeImg').setValue(Number(this.cardForm.value.codeImg));
    const dataToSend = {
      ...this.cardForm.value,
      id: this.cardInfo.id,
      img64Upload: this.cardInfo.img64Upload,
    };

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.cardForm = this.fb.group({
      title: ['', Validators.required],
      order: [null, Validators.required],
      img: [''],
      img64: [''],
      subTitle: ['', Validators.required],
      codeImg: [3],
    });
  }

  private updateForm(): any {
    this.cardForm.get('title').setValue(this.cardInfo.title);
    this.cardForm.get('subTitle').setValue(this.cardInfo.subTitle);
    this.cardForm.get('order').setValue(this.cardInfo.orderId);
    // this.cardForm.get('codeImg').setValue(this.cardInfo.codeImg);
    this.cardForm.get('img64').setValue(this.cardInfo.img);
    // this.cardForm.get('img').setValue(this.cardInfo.img);
    this.cardInfo.img64Upload = false;
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 200 && image.height <= 150) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.cardForm.get('img').setValue((event.target.files[0]).name);
          this.cardForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          this.cardInfo.img64Upload = true;
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 200px x 150px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

}
